module.exports = __webpack_public_path__ + "img/bcn.c60a60ca.svg";